import { subscribeMessage, doPostMessage, setWindowDoPostMessage, setFrameKey } from '../../core/services/MessageService';
import {
    MESSAGE_KEY_IMPORT_CSS_URL,
    MESSAGE_KEY_IMPORT_CSS_INLINE,
    MESSAGE_KEY_ORIGIN,
    MESSAGE_DATA_OBJECT_KEY,
    MESSAGE_KEY_SUBMIT_SUCCESS,
    MESSAGE_KEY_SCROLL_TO_FRAME,
    MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN,
    MESSAGE_KEY_DO_RENDER_CAPTCHA,
    MESSAGE_KEY_REDIRECT,
    MESSAGE_KEY_FORM_SIZE,
    MESSAGE_KEY_ON_CAPTCHA_TOKEN,
    MESSAGE_KEY_RENDER_FORM_SOURCE,
    MESSAGE_KEY_RETRIEVE_FORM_SOURCE,
    MESSAGE_KEY_SET_HTML_FONT_SIZE,
    MESSAGE_KEY_HIDE_FRAME,
    MESSAGE_KEY_SUBMIT_FAILED,
    RENDER_MODE_ON_SITE,
    RENDER_MODE_IFRAME,
    MESSAGE_KEY_ON_FORM_READY,
    URL_PARAMETER_FORM_UUID,
    URL_PARAMETER_FRAME_KEY,
    URL_PARAMETER_ENDPOINT,
    URL_PARAMETER_RECIPIENT_ORIGIN,
    URL_PARAMETER_RENDER_MODE,
    MESSAGE_KEY_ON_FORM_RENDERED,
    MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT,
    MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE,
    MESSAGE_KEY_SET_FIELD_VALUE,
    MESSAGE_KEY_PAGE_CHANGED,
    MESSAGE_KEY_CUSTOM_HTML_WIDGET,
    MESSAGE_KEY_ON_FORM_BEFRORE_RENDER,
    MESSAGE_KEY_CAN_RENDER_FORM,
    URL_PARAMETER_SITE_UUID,
} from '../../core/const/Constant.js';

import {
    APP_EMBED_FRAME_URL,
    APP_FORM_CSS_URL,
    APP_FORM_JS_URL
} from '../../ENV.js';

import Logger from '../../core/utils/Logger.js';

const CURRENT_ORIGIN = window.location.origin;

const newIFrame = ({ siteUUID = '', formUUID = '', endpoint = '', defaultHeight, frameKey, preview = '', mode = RENDER_MODE_IFRAME }) => {
    const params = buildUrlParameters({
        [URL_PARAMETER_SITE_UUID]: siteUUID,
        [URL_PARAMETER_FORM_UUID]: formUUID,
        'preview': preview,
        [URL_PARAMETER_FRAME_KEY]: frameKey,
        [URL_PARAMETER_RENDER_MODE]: mode,
        [URL_PARAMETER_ENDPOINT]: encodeURIComponent(endpoint),
        [URL_PARAMETER_RECIPIENT_ORIGIN]: decodeURIComponent(window.location.origin),
    });


    const elem = document.createElement('iframe');
    elem.className = 'tai-frame';
    elem.id = 'tai-' + formUUID;
    elem.src = `${APP_EMBED_FRAME_URL}?${params}`.replace("??", '?');
    elem.sandbox = 'allow-scripts allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation allow-pointer-lock allow-modals';
    // elem.referrerpolicy = 'origin';
    elem.setAttribute('style', `width:100%; padding: 0; margin: 0; border: none;overflow:hidden;height: ${defaultHeight}px;min-height:${defaultHeight};transition:none`);
    return elem;
};

const generateFrameKey = () => Date.now().toString(36) + Math.random().toString(36).substring(2);

const buildUrlParameters = obj => new URLSearchParams(obj).toString();

const isRenderAsIFrame = mode => mode !== RENDER_MODE_ON_SITE;

const formatString = (str) => {
    return str.replace(/ /g, '').replace(/(\r\n|\n|\r)/gm, "");
}

const newScriptTag = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    return script;
}

const newCssTag = (src) => {
    const link = document.createElement('link');
    link.href = src;
    link.rel = 'stylesheet';
    return link;
}

/**
 * 
 * @param {TaiFrame} taiFrame 
 * @returns 
 */
const doProcessIncomingMessage = (taiFrame) => {

    const getCaptchaUrl = key => `https://www.google.com/recaptcha/api.js?render=${key}`;
    let isGCapchaAdded = false,
        gcapchakey = '';

    const actions = {
        [MESSAGE_KEY_FORM_SIZE]: function ({ width, height }) {
            taiFrame.iframe.style.height = height + 'px';
            return Promise.resolve();
        },
        [MESSAGE_KEY_REDIRECT]: function ({ url, target }) {
            window.location.href = url;
            return Promise.resolve();
        },
        [MESSAGE_KEY_DO_RENDER_CAPTCHA]: function ({ key, version }) {
            return new Promise(next => {
                gcapchakey = key;
                const script = document.createElement('script');
                script.src = getCaptchaUrl(key);
                taiFrame.container.appendChild(script);
                script.onload = () => {
                    grecaptcha.ready(function () {
                        isGCapchaAdded = true;
                        next();
                    });
                };
            })
        },
        [MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN]: function (value) {
            if (!isGCapchaAdded || !grecaptcha) return Promise.resolve('');
            grecaptcha.execute(gcapchakey, { action: 'submit' }).then(function (token) {
                doPostMessage(MESSAGE_KEY_ON_CAPTCHA_TOKEN, token)
            });
            return Promise.resolve();
        },
        [MESSAGE_KEY_SCROLL_TO_FRAME]: function (value) {
            if (typeof taiFrame.iframe.scrollIntoView === 'function') {
                taiFrame.iframe.scrollIntoView();
            }
            return Promise.resolve();
        },
        [MESSAGE_KEY_SUBMIT_SUCCESS]: function (value) {
            taiFrame.onFormSubmitted();
            return Promise.resolve();
        },
        [MESSAGE_KEY_SUBMIT_FAILED]: function (value) {
            taiFrame.onFormSubmitFailed();
            return Promise.resolve();
        },
        [MESSAGE_KEY_RENDER_FORM_SOURCE]: function (value) {
            taiFrame.doRenderSource(value);
            return Promise.resolve();
        },
        [MESSAGE_KEY_ON_FORM_READY]: function () {
            taiFrame.onFormReady();
            return Promise.resolve();
        },
        [MESSAGE_KEY_ON_FORM_RENDERED]: function () {
            taiFrame.onFormRendered();
            return Promise.resolve();
        },
        [MESSAGE_KEY_PAGE_CHANGED]: function (pageIndex) {
            taiFrame.onPageChanged(pageIndex);
        },
        [MESSAGE_KEY_ON_FORM_BEFRORE_RENDER]: function () {
            taiFrame.onFormBeforeRender()
        }
    }

    const unsubcribes = [];
    for (const k in actions) {
        const un = subscribeMessage(k, actions[k]);
        unsubcribes.push(un);
    }
    return () => {
        while (unsubcribes.length > 0) {
            unsubcribes.shift().call(null);
        }
    }
};

const dispatchCustomEvent = (type, detail) => {
    const ctEven = new CustomEvent(type, {
        detail
    })
    window.dispatchEvent(ctEven);
    return () => {

    }
}


class TaiFrame {

    origin = window.location.origin;
    formUUID = '';
    container = null;
    frameKey = generateFrameKey();
    __iframe = null;
    importCSSUrls = [];
    importCSSInline = '';
    fnOnSubmitted = () => { }
    fnOnSubmitFailed = () => { }
    fnOnPageChanged = () => { }
    fnOnFormInit = () => { }
    mode = 'iframe';
    htmlTermCondition = '';
    validateMessage
    customField

    constructor({
        container,
        site = '',
        formUUID = '',
        endpoint = '',
        mode = 'iframe',
        importCSSUrls = [],
        importCSSInline = '',
        preview = '',
        defaultHeight = '350px',
        onInit = () => { },
        onSubmitted = () => { },
        onSubmitFailed = () => { },
        onPageChanged = (pageIndex) => { },
        htmlTermCondition = '',
        validateMessage,
        customField
    }) {
        this.formUUID = formUUID;
        this.fnOnFormInit = onInit;
        this.fnOnSubmitted = onSubmitted;
        this.fnOnSubmitFailed = onSubmitFailed;
        this.fnOnPageChanged = onPageChanged;
        this.onFrameRendered = this.onFrameRendered.bind(this);
        this.container = (typeof container === 'string' ? document.querySelector(container) : container);
        this.importCSSUrls = importCSSUrls;
        this.importCSSInline = importCSSInline;
        this.mode = mode;
        this.htmlTermCondition = htmlTermCondition;
        this.validateMessage = validateMessage;
        this.customField = customField;

        // init iframe
        this.iframe = newIFrame({ siteUUID: site, formUUID, endpoint, defaultHeight, frameKey: this.frameKey, preview, mode });
        this.iframe.addEventListener('load', () => {
            this.onFrameRendered();
        })
        this.container.appendChild(this.iframe);
        setWindowDoPostMessage(this.iframe.contentWindow);
    }

    get iframe() {
        return this.__iframe;
    }

    set iframe(ifr) {
        this.__iframe = ifr;
    }

    onFormReady() {
        if (!isRenderAsIFrame(this.mode)) {
            doPostMessage(MESSAGE_KEY_RETRIEVE_FORM_SOURCE, 1);
            this.hideFrame();
            return
        }
        // send inline style when html contain style[data-tai-form-style] 
        const styleTags = document.querySelectorAll('style[data-tai-form-style]');
        styleTags.forEach(tag => {
            const styleStr = formatString(tag.innerHTML);
            doPostMessage(MESSAGE_KEY_IMPORT_CSS_INLINE, styleStr);
        })
        doPostMessage(MESSAGE_KEY_SET_HTML_FONT_SIZE, getComputedStyle(document.querySelector('html')).fontSize);
        doPostMessage(MESSAGE_KEY_IMPORT_CSS_URL, this.importCSSUrls);
        doPostMessage(MESSAGE_KEY_IMPORT_CSS_INLINE, formatString(this.importCSSInline));


    }

    onFormBeforeRender() {
        if (this.customField) {
            doPostMessage(MESSAGE_KEY_CUSTOM_HTML_WIDGET, { formId: this.formUUID, customField: this.customField })
        }
        if (this.htmlTermCondition.length > 0) {
            doPostMessage(MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT, this.htmlTermCondition);
        }
        if (this.validateMessage) {
            doPostMessage(MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE, this.validateMessage);
        }
        doPostMessage(MESSAGE_KEY_CAN_RENDER_FORM, true)

    }

    onFormRendered() {
        const tryEmitTaiFormRenderedInGlobal = () => {
            if (typeof window['onTaiFormRendered'] === 'function') {
                window['onTaiFormRendered'].call(this, this);
            }
        }

        dispatchCustomEvent('taiFormRendered', {
            uuid: this.formUUID,
        })
        this.fnOnFormInit.call(null);
        tryEmitTaiFormRenderedInGlobal();
    }

    registerValidateMessage(validateMessage) {
        this.validateMessage = validateMessage;
        doPostMessage(MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE, this.validateMessage);
    }

    onFrameRendered() {
        doProcessIncomingMessage(this);

        // Set frame key for Message service
        setFrameKey(this.frameKey);
        doPostMessage(MESSAGE_KEY_ORIGIN, CURRENT_ORIGIN);
    }

    onFormSubmitted() {
        this.fnOnSubmitted.call(null);
        dispatchCustomEvent('taiFormSubmitSuccess', {
            uuid: this.formUUID,
        })

    }

    onFormSubmitFailed() {
        this.fnOnSubmitFailed.call(null);
        dispatchCustomEvent('taiFormSubmitFailed', {
            uuid: this.formUUID,
        })
    }

    doRenderSource(value) {
        const { scripts, styles } = value;
        const scriptTag = newScriptTag(APP_FORM_JS_URL);
        const styleTag = newCssTag(APP_FORM_CSS_URL);

        const onScriptLoaded = new Promise((resolve, reject) => {
            scriptTag.onload = () => {
                resolve();
            }
        });

        const onStyleLoaded = new Promise((resolve, reject) => {
            resolve();
        })

        Promise.all([onScriptLoaded, onStyleLoaded]).then(() => {
            if (typeof window.TaiForm === 'function') {
                const taiForm = new TaiForm({ holder: this.container, uuid: this.formUUID })
            }
        })

        const firstStyle = document.querySelector('link[rel=stylesheet]');
        document.head.insertBefore(styleTag, firstStyle)
        this.container.appendChild(scriptTag);
    }

    setFieldValue(fieldCode, value) {
        doPostMessage(MESSAGE_KEY_SET_FIELD_VALUE, { fieldCode, value });
    }

    hideFrame() {
        this.iframe.style.display = 'none';
        this.iframe.style.maxWidth = '0px';
        this.iframe.style.maxHeight = '0px';
        this.iframe.style.zIndex = '-1';
        this.iframe.style.opacity = '0';

    }

    onPageChanged(pageIndex) {
        this.fnOnPageChanged.call(null, pageIndex);
    }
}

export default TaiFrame;